import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { VnskySupportAlertInjection } from "features/vnskySupportAlert/di/VnskySupportAlertInjection";
import { injectable } from "tsyringe";
import { AlertSupportRequestEntity } from "../entities/AlertSupportRequestEntity";
import { AlertSupportResponseEntity } from "../entities/AlertSupportResponseEntity";
import { IAlertSupportRepository } from "../repositories/IAlertSupportRepository";

@injectable()
export class AlertSupportUseCase {
  private alertSupportRepo: IAlertSupportRepository;

  constructor() {
    this.alertSupportRepo = VnskySupportAlertInjection.getRepo();
  }

  async getAlerts(
    params: AlertSupportRequestEntity,
  ): Promise<ListBaseApiResponseModel<AlertSupportResponseEntity>> {
    return await this.alertSupportRepo.getAlerts(params);
  }
}
